import useCountdown from '../../hooks/useCountdown';

export default function CountdownTimer({ expiresAt }) {
  const timeLeft = useCountdown(expiresAt);

  if (!timeLeft) {
    return <span className="text-red-600 font-bold">Expired</span>;
  }

  const { hours, minutes, seconds, totalSeconds } = timeLeft;
  
  let colorClass = "text-emerald-600";
  if (totalSeconds < 3600) {
    colorClass = "text-red-600 animate-pulse"; // Under 1 hour
  } else if (totalSeconds < 86400) {
    colorClass = "text-amber-600"; // Under 24 hours
  }

  return (
    <span className={`font-mono font-medium ${colorClass}`}>
      {hours}h {minutes}m {seconds}s
    </span>
  );
}
